<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color bg-wite">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden px-5 lg:block lg:w-1/2  py-5 color-bg-login min-h-login">

                <img class="mb-5 max-w-logo d-block m-auto" src="@/assets/images/logo/logo-full.svg" alt="registerImg">
                <img src="@/assets/images/pages/reset.svg" alt="login" class="mx-auto">

            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container py-login">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Recupera tu contraseña</h4>
                  <p>Ingresa tu correo electrónico, te enviaremos un enlace para que puedas restablecer tu contraseña.</p>
                </div>

                <div>

                  <vs-input
                      label-placeholder="Correo electrónico"
                      name="email"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      v-model="email"
                      class="w-full mb-5"/>

                  <vs-button @click="submitForgotPasswordRequest" ref="loadableButton" id="button-with-loading" class="vs-con-loading__container" type="relief" vslor="primary">Enviar solicitud</vs-button>
                  <vs-button type="border" to="/login" class="float-right">Regresar al inicio</vs-button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default{
  data() {
    return {
      email: "",
    }
  },
  created() {
    this.logout()
  },
  methods: {
    submitForgotPasswordRequest() {
      const {email} = this;
      this.$store.dispatch("alert/clear", {});
      if (email) {
        this.$vs.loading({
          background: 'primary',
          color: '#fff',
          container: "#button-with-loading",
          scale: 0.45
        });
        this.$store.dispatch("account/forgotPasswordRequest", {email: this.email})
        .then(
          () => {
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          },
          () => {
            this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          }
        )
      } else {
        this.$store.dispatch("alert/error", "Ingrese los datos requeridos");
      }
    }

  }
}
</script>

<style>
.vs-button-primary.vs-button-relief {
  -webkit-box-shadow: none;
  box-shadow: none;
}
</style>
